module.exports = __webpack_public_path__ + "img/product22.53fc67ba.png";